import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import "./EnquiryMonth.css";

export default function EnquiryMonths() {
  const { mode } = useParams();
  const nav = useNavigate();
  const { state } = useLocation();
  const [months, setMonths] = useState(15);

  if (!state?.value) {
    nav(`/enquiry/${mode}`);
  }

  const onSearch = () => {
    const value = state.value;
    const today = new Date();
    const endDate = today.toISOString().slice(0,10);
    const start = new Date(today);
    start.setMonth(start.getMonth() - Number(months || 1));
    const startDate = start.toISOString().slice(0,10);
    nav(`/enquiry/${mode}/results`, { state: { value, months: Number(months), startDate, endDate } });
  };

  return (
    <div className="enquiryMonths">
      <h2>Search last N months</h2>
      <label className="label">Number of months</label>
      <input
        className="input"
        type="number"
        min="1"
        value={months}
        onChange={(e) => setMonths(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSearch()}
      />
      <div className="row" style={{ marginTop: "1rem" }}>
        <button className="btn secondary" onClick={() => nav(-1)}>Back</button>
        <button className="btn primary" onClick={onSearch}>Search</button>
      </div>
    </div>
  );
}
